import store from '@/store'
const redirectAfterAuth = async (to, from, next) => {
    const isServicesOrder = to.name === 'services.order.summary'
    const redirectAfterAuth = store.getters['auth/redirectAfterAuth']
    const isAuth = localStorage.getItem('token')    
    if(isAuth && redirectAfterAuth) {
        console.log("redirectAfterAuth")
        store.commit("auth/CLEAR_REDIRECT_AFTER_AUTH")
        return next({
            name: redirectAfterAuth,
            replace: true
        })        
    }    
    if(!isAuth && isServicesOrder) {
        console.log("SET_REDIRECT_AFTER_AUTH")
        store.commit("auth/SET_REDIRECT_AFTER_AUTH", to.name)
    }
}

const checkAuthInHome = async (to, from, next) => {
    const root = to.path === '/'
    const isAuth = localStorage.getItem('token')    
    if(isAuth && root) {
        return next({
            name: 'home',
            replace: true
        })
    }
}

const loader = async (to, from, next) => {
    if(to.meta.loader) {
        store.commit("global/SHOW_LOADER")
    }    
}

export {
    redirectAfterAuth,
    checkAuthInHome,
    loader
}



// WEBPACK FOOTER //
// ./src/router/hooks.js